import styled, { css } from 'styled-components';
import { Th } from '../Tabela/styles';
import { media } from '../../styles/theme';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.lg};
  padding: ${({ theme }) => theme.espaco.xl};
  background-color: ${({ theme }) => theme.cores.card};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.card};

  ${media.mobile} {
    padding: ${({ theme }) => theme.espaco.lg};
  }

  h2 {
    font-size: ${({ theme }) => theme.fonte.h3};
    color: ${({ theme }) => theme.cores.ink};
  }
`;

export const Bloco = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.sm};

  h3 {
    font-size: ${({ theme }) => theme.fonte.body};
    font-weight: 600;
    color: ${({ theme }) => theme.cores.inkSecondary};
  }
`;

export const LinhaEntrada = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.sm};

  > div {
    flex: 0 1 220px;
  }

  ${media.mobile} {
    > div {
      flex: 1;
    }
  }
`;

export const Chips = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.espaco.sm};
  list-style: none;
`;

export const Chip = styled.li`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.xs};
  padding: ${({ theme }) => `${theme.espaco.xs} ${theme.espaco.xs} ${theme.espaco.xs} ${theme.espaco.md}`};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.pill};
  background-color: ${({ theme }) => theme.cores.surface};
  color: ${({ theme }) => theme.cores.ink};
  font-size: ${({ theme }) => theme.fonte.body};

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: ${({ theme }) => theme.raio.pill};
    background: transparent;
    color: ${({ theme }) => theme.cores.inkMuted};
    cursor: pointer;

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.cores.surfaceHover};
      color: ${({ theme }) => theme.cores.ink};
    }

    &:disabled {
      opacity: 0.4;
      cursor: default;
    }
  }

  ${media.mobile} {
    button {
      width: 32px;
      height: 32px;
    }
  }
`;

export const Aviso = styled.p`
  font-size: ${({ theme }) => theme.fonte.body};
  color: ${({ theme }) => theme.cores.inkMuted};
`;

export const Resumo = styled.p<{ $alerta?: boolean }>`
  padding: ${({ theme }) => `${theme.espaco.sm} ${theme.espaco.md}`};
  border-radius: ${({ theme }) => theme.raio.md};
  font-size: ${({ theme }) => theme.fonte.body};
  background-color: ${({ theme, $alerta }) => ($alerta ? theme.cores.warningSoft : theme.cores.surface)};
  color: ${({ theme, $alerta }) => ($alerta ? theme.cores.warning : theme.cores.inkSecondary)};
`;

export const Celula = styled.td<{ $tipo: 'existente' | 'nova' }>`
  padding: 8px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.cores.border};
  text-align: center;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.cores.ink};

  ${({ $tipo, theme }) => $tipo === 'nova' && css`
    background-color: ${theme.cores.goodSoft};
    color: ${theme.cores.good};
    font-size: ${theme.fonte.caption};
    font-weight: 600;
  `}

  .principal {
    margin-left: ${({ theme }) => theme.espaco.xs};
    color: ${({ theme }) => theme.cores.accent};
    vertical-align: -1px;
  }
`;

export const CabecalhoLinha = styled.th`
  padding: 8px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.cores.border};
  font-weight: 600;
  color: ${({ theme }) => theme.cores.ink};
  white-space: nowrap;
  text-align: left;
`;

export const ListaCores = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.xs};
  max-height: 50vh;
  overflow-y: auto;
  margin-top: ${({ theme }) => theme.espaco.md};

  ${media.mobile} {
    max-height: none;
  }
`;

export const Legenda = styled.p`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.md};
  font-size: ${({ theme }) => theme.fonte.caption};
  color: ${({ theme }) => theme.cores.inkMuted};

  svg {
    color: ${({ theme }) => theme.cores.accent};
    vertical-align: -1px;
  }
`;

export const ColunaTamanho = styled(Th)`
  text-align: center;
`;
